"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BurgerMenuLink = void 0;
var UserAction = _interopRequireWildcard(require("@ori-events/user-action"));
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("../../../constants");
var _navigation = require("../../../context/navigation");
var _hooks = require("../../../hooks");
var _models = require("../../../models");
var _net = require("../../../models/graphql-types/net");
var _utils = require("../../../utils");
var _BurgerMenuContent = require("../BurgerMenuContent");
var _constants2 = require("../constants");
var _utils2 = require("../utils");
var _TitleWithIcon = require("./TitleWithIcon");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BurgerMenuLink = ({
  link
}) => {
  const {
    activeLink,
    toggleActiveLink
  } = (0, _navigation.useActiveLink)();
  const isMobile = (0, _hooks.useIsMobile)();
  const isAlwaysActiveLink = _models.AlwaysActiveLinks.includes(link.linkType);
  const isActiveLink = activeLink?.url === link.url && activeLink?.linkType === link.linkType;
  const burgerMenuContentRef = (0, _react.useRef)(null);
  const burgerMenuContentStyle = {
    overflow: 'hidden',
    height: (0, _utils2.getBurgerMenuHeight)({
      burgerMenuHeight: burgerMenuContentRef.current?.offsetHeight,
      isActiveLink,
      isAlwaysActiveLink
    })
  };
  const isBestOffers = (0, _react.useMemo)(() => link.linkType === _net.NavigationLinkType.FocusPage, [link.linkType]);
  const areBestOffersValid = (0, _react.useMemo)(() => isBestOffers ? link.children.some(child => child.children.length > 0) : false, [isBestOffers, link.children]);
  const handleAnalyticsClick = (0, _react.useCallback)(() => {
    if (link.linkType === _net.NavigationLinkType.Catalogue) {
      UserAction.dispatch(_constants.CLICK_CATALGOUE);
    }
  }, [link.linkType]);
  const updateActiveLink = (0, _react.useCallback)(() => {
    toggleActiveLink(link);
  }, [link, toggleActiveLink]);
  const categoryName = link.url?.split('/').reverse().find(el => el);
  const category = Object.values(_models.Categories).find(cat => cat === categoryName);
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  if (isMobile) {
    const shouldDisplayArrow = Boolean(link.children.length);
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.BurgerMenuLinkListElement, {
      "data-testid": getTestId(_constants2.BURGER_MENU_LINK_ROOT_MOBILE),
      id: category ?? undefined,
      children: [isAlwaysActiveLink ? null : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.BurgerMenuLinkCategory, {
        category: category,
        "data-testid": getTestId(_constants2.BURGER_MENU_LINK_CATEGORY_MOBILE),
        isActiveLink: isActiveLink,
        onClick: updateActiveLink,
        onKeyDown: (0, _utils.onEnterKey)(updateActiveLink),
        children: [link.url ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BurgerMenuLinkLink, {
          href: isBestOffers && !areBestOffersValid ? link.url : undefined,
          "data-testid": getTestId(_constants2.BURGER_MENU_LINK),
          onClick: handleAnalyticsClick,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TitleWithIcon.TitleWithIcon, {
            linkType: link.linkType,
            linkTitle: link.title
          })
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BurgerMenuLinkLink, {
          "data-testid": getTestId(_constants2.BURGER_MENU_LINK),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TitleWithIcon.TitleWithIcon, {
            linkType: link.linkType,
            linkTitle: link.title
          })
        }), shouldDisplayArrow ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BurgerMenuLinkIconWrapper, {
          "data-testid": getTestId(_constants2.BURGER_MENU_LINK_ICON_WRAPPER),
          isActiveLink: isActiveLink,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowDownThin, {
            fontSize: "inherit"
          })
        }) : null]
      }), isActiveLink || isAlwaysActiveLink ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: burgerMenuContentStyle,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_BurgerMenuContent.BurgerMenuContent, {
          contentRootRef: burgerMenuContentRef,
          "data-testid": getTestId(_constants2.BURGER_MENU_CONTENT),
          link: link
        })
      }) : null]
    }, link.linkType);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BurgerMenuLinkListElement, {
    "data-testid": getTestId(_constants2.BURGER_MENU_LINK_ROOT),
    id: category ?? undefined,
    onClick: updateActiveLink,
    children: category === undefined ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.BurgerMenuTopItemLink, {
      "data-testid": getTestId(_constants2.BURGER_MENU_TOP_ITEM_LINK),
      href: isBestOffers && !areBestOffersValid ? link.url ?? undefined : undefined,
      tabIndex: 0,
      role: "button",
      onClick: handleAnalyticsClick,
      onKeyDown: (0, _utils.onEnterKey)(updateActiveLink),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TitleWithIcon.TitleWithIcon, {
        linkType: link.linkType,
        linkTitle: link.title
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowRightThin, {})]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.BurgerMenuLinkCategory, {
      category: category,
      "data-testid": getTestId(_constants2.BURGER_MENU_LINK_CATEGORY),
      isActiveLink: isActiveLink,
      tabIndex: 0,
      role: "button",
      onClick: handleAnalyticsClick,
      onKeyDown: (0, _utils.onEnterKey)(updateActiveLink),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: link.title
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowRightThin, {})]
    })
  }, link.id);
};
exports.BurgerMenuLink = BurgerMenuLink;
